import { render, staticRenderFns } from "./TestQuestionItem.vue?vue&type=template&id=fe5e4448&"
import script from "./TestQuestionItem.vue?vue&type=script&lang=js&"
export * from "./TestQuestionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports